import { render, staticRenderFns } from "./FullTextMark.vue?vue&type=template&id=1bb2c300&scoped=true&"
import script from "./FullTextMark.vue?vue&type=script&lang=ts&"
export * from "./FullTextMark.vue?vue&type=script&lang=ts&"
import style0 from "./FullTextMark.vue?vue&type=style&index=0&id=1bb2c300&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb2c300",
  null
  
)

export default component.exports